// React Thirty Party Library
import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Col, Row, Card, Checkbox,} from "antd";

//  Constants Library

// Components Library
import { BtnSubmit} from "../../../../../../components";

// Services Library

// Redux Actions

// Styles Library
import "./index.css"

const DrawerFormGroup = (props) => {
  const { isOpen, setIsOpen, type, form, handleSave, initialCheckedValue } = props;

  const [checkedValues, setCheckedValues] = useState(null);

  useEffect(() => {
    if (type === 'edit' && initialCheckedValue) {
      setCheckedValues(initialCheckedValue);
    }
  }, [type, initialCheckedValue]);

  const handleCheckboxChange = (value) => {
    setCheckedValues(value);
    form.setFieldsValue({ groupColor: value });
  };

  const colors = [
    { value: '#F4F6FA', className: 'color1' },
    { value: '#F1F4FF', className: 'color2' },
    { value: '#DAF9FF', className: 'color3' },
    { value: '#F8F1FF', className: 'color4' },
    { value: '#FFF3D0', className: 'color5' },
    { value: '#FED0D0', className: 'color6' },
    { value: '#C1EFDF', className: 'color7' },
  ];

  const ActionButton = (
    <Form.Item style={{ paddingTop: '20px' }}>
      <div>
        <BtnSubmit
          display='inline-block'
          text={type === 'add' ? 'Create' : 'Save'}
          bgColor='#0E2483'
          color='white'
          padding='9px 18px'
          onClick={() => {
              handleSave();
              setIsOpen(false);
          }}
        />
        {type === 'add' && (
          <BtnSubmit
            display='inline-block'
            text='Create & add another'
            bgColor='#0E2483'
            color='white'
            padding='9px 18px'
            onClick={() => {
              form.resetFields();
            }}
          />
        )}
        <BtnSubmit
          display='inline-block'
          text='Cancel'
          bgColor='transparent'
          color='#C8C8C8'
          padding='9px 18px'
          border='1px solid #C8C8C8'
          onClick={() => {
            form.resetFields();
            setIsOpen(false);
          }}
        />
      </div>
    </Form.Item>
  );

  return (
    <Drawer
      title={type === 'add' ? 'Create Employee Group' : 'Edit Employee Group'}
      placement='right'
      closable={false}
      width={410}
      onClose={() => setIsOpen(false)}
      footer={ActionButton}
      open={isOpen}
      style={{
        textAlign: 'center',
        fontSize: '20px',
      }}
    >
      <Form form={form} layout='vertical'>
        <Row>
          <Col style={{ width: '100%', marginBottom: '10px' }}>
            <label htmlFor='groupName' className='labelInput'>
              Employee Group Name <span style={{ color: 'red' }}>*</span>
            </label>
            <Form.Item
              name='groupName'
              rules={[
                {
                  required: true,
                  message: 'Employee ID is required',
                },
              ]}
            >
              <Input className='inputForm' />
            </Form.Item>
          </Col>
          <Col style={{ width: '100%', height: '40px' }}>
            <label htmlFor='groupColor' className='labelInput'>
              Set Color <span style={{ color: 'red' }}>*</span>
            </label>
            <Card className='inputForm' style={{height: "68px"}}>
              <Form.Item name='groupColor'>
                {colors.map((color) => (
                    <Checkbox
                      key={color.value}
                      className={`custom-checkbox ${color.className}`}
                      checked={checkedValues === color.value}
                      onChange={() => handleCheckboxChange(color.value)}
                    />
                  ))}
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default DrawerFormGroup;